<template>
	<div class="news">
		<section class="news-detail">
			<div class="container">
				<h1>{{ news.title }}</h1>

				<div class="thumb">
					<img :src="news.coverImg">
				</div>
				
				<div v-html="news.content"></div>
			</div>
		</section>


		<footer>
			<div class="container">
				<div class="copyright">
					Copyright &copy; 2019 GraceMed. All Rights Reserved.
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import { db } from '../main'

export default {
	name: 'contactus',
	components: {

	},
	data () {
		return {
			publicPath: process.env.BASE_URL,
			mobileNav: false,
			id: null,
			news: []
		}
	},
	methods: {
		toggleMobileNav() {
			this.mobileNav = !this.mobileNav
		}
	},
	created() {
		this.id = this.$route.params.id;

		db.collection('news')
		.doc(this.id)
		.get()
		.then(snapshot => {
			const document = snapshot.data()	
			this.news = document;
		})	
	}
}
</script>

<style>
.news-detail {
	padding-top: 70px;
	padding-bottom: 50px;
}

.news-detail h1 {
	color: #f39d00;
	border-bottom: 1px solid #9c8b72;
	padding: 20px 0;
}

.news-detail a {
	color: #75787b;
	text-decoration: none;
}

.news-detail img,
.news-detail .thumb img {
	width: 100%;
}

@media handheld,only screen and (max-width: 800px) {
	.news-detail h1 {
		font-size: 1.5em;
		margin-bottom: 20px;
	}
}
</style>